export default __webpack_public_path__ + "f85de6ad47039eaeead70d3517f8bbbb.png";